import _regenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import api from '@/api';
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  name: 'ByMemberResourceDownAll',
  data: function data() {
    return {
      title: '',
      form: {
        matchmakerId: ''
      },
      rules: {
        matchmakerId: [{
          required: true,
          message: '红娘ID不能为空',
          trigger: 'blur'
        }]
      }
    };
  },
  methods: {
    downAllMatchmakerResources: function downAllMatchmakerResources() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _this.$refs.form.validate(/*#__PURE__*/function () {
                var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(valid) {
                  var _t;
                  return _regenerator().w(function (_context) {
                    while (1) switch (_context.p = _context.n) {
                      case 0:
                        if (!valid) {
                          _context.n = 5;
                          break;
                        }
                        _context.p = 1;
                        _context.n = 2;
                        return api.downAllMatchmakerResources({
                          matchmakerId: _this.form.matchmakerId
                        });
                      case 2:
                        _this.$message.success('下架成功');
                        _this.$emit('initTableData');
                        _this.handleClose();
                        _context.n = 4;
                        break;
                      case 3:
                        _context.p = 3;
                        _t = _context.v;
                        _this.$message.error(_t.message || '操作失败');
                      case 4:
                        _context.n = 6;
                        break;
                      case 5:
                        return _context.a(2, false);
                      case 6:
                        return _context.a(2);
                    }
                  }, _callee, null, [[1, 3]]);
                }));
                return function (_x) {
                  return _ref.apply(this, arguments);
                };
              }());
            case 1:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    setTitle: function setTitle(title) {
      this.title = title;
    },
    setData: function setData(data) {
      if (this.$refs.form !== undefined) {
        this.$refs.form.resetFields();
      }
      this.form.matchmakerId = '';
    },
    handleClose: function handleClose(done) {
      this.$emit('close');
    }
  },
  created: function created() {}
};